"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../app-reduxs/app/slice"));
const Colors_1 = __importDefault(require("../../assets/colors/Colors"));
const IC_X_1 = __importDefault(require("../../assets/icons/IC_X"));
const IconCheckModal_1 = __importDefault(require("../../assets/icons/IconCheckModal"));
const images_1 = require("../../assets/images");
const constants_1 = require("../../constants");
const rootNavigation_1 = require("../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../navigators/Routes"));
const Basic_1 = __importDefault(require("../../networking/apis/Basic"));
const Timeline_1 = __importDefault(require("../../networking/apis/Timeline"));
const helpler_1 = require("../../utils/helpler");
const scale_1 = require("../../utils/scale");
const button_1 = require("../button");
const loading_1 = require("../loading");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const ModalUnfollowUser_1 = __importDefault(require("./ModalUnfollowUser"));
const CONFIRM_MODAL_HEIGHT = (0, scale_1.scale)(58);
const UserItem = ({ item, index, isLastItem = false, hiddenFollowButton, onCloseModal, onFollowUser, onUnfollowUser, }) => {
    const isFollowed = item.is_followed == 1;
    const navigateToUserProfile = () => {
        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
            screen: Routes_1.default.USER_PROFILE,
            params: {
                userHandle: item.user_handle,
            },
        });
        onCloseModal?.();
    };
    const buttonUnFollowRef = (0, react_1.useRef)(null);
    return (react_1.default.createElement(react_native_1.View, { key: index, style: [
            styles.userItem,
            {
                borderBottomWidth: isLastItem ? 0 : (0, scale_1.scale)(1),
            },
        ] },
        react_1.default.createElement(react_native_1.Pressable, { onPress: navigateToUserProfile },
            react_1.default.createElement(react_native_1.Image, { source: item?.thumbnail_url ? { uri: item?.thumbnail_url } : images_1.images?.AvatarDefaul, style: styles.userAvatar })),
        react_1.default.createElement(react_native_1.View, { style: styles.userInfo },
            react_1.default.createElement(react_native_1.View, { style: { width: '100%', alignItems: 'flex-start' } },
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles.userNickname, numberOfLines: 1, onPress: navigateToUserProfile }, item?.nickname || constants_1.DEFAULT_NAME)),
            react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles.userHandle, numberOfLines: 1 },
                "@",
                item?.user_handle)),
        !hiddenFollowButton && (isFollowed ? (react_1.default.createElement(react_native_1.TouchableOpacity, { style: [styles.button, { backgroundColor: '#DDDDDD' }], onPress: (event) => {
                const position = buttonUnFollowRef.current?.getBoundingClientRect();
                onUnfollowUser(event, item, position);
            }, onLayout: (event) => {
                console.log(event.nativeEvent.layout.y);
            }, ref: buttonUnFollowRef },
            react_1.default.createElement(CustomText_1.default, { style: styles.buttonLabel }, "\u30D5\u30A9\u30ED\u30FC\u4E2D"))) : (react_1.default.createElement(button_1.LinearButton, { title: "\u30D5\u30A9\u30ED\u30FC", textStyle: [styles.buttonLabel, { color: '#FEFEFE' }], style: styles.button, onPress: () => onFollowUser(item.user_id, item.nickname || constants_1.DEFAULT_NAME) })))));
};
const ModalHistoryLike = (props) => {
    const insets = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { tweetId, onClose, label } = props;
    const [data, setData] = (0, react_1.useState)([]);
    const [modalPosition, setModalPosition] = (0, react_1.useState)({ x: 0, y: 0 });
    const [heightModal, setModalHeight] = (0, react_1.useState)(0);
    const [selectedUser, setSelectedUser] = (0, react_1.useState)();
    const [unfollowVisible, setUnfollowVisible] = (0, react_1.useState)(false);
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [toast, setToast] = (0, react_1.useState)('');
    const refIsCallingAPI = (0, react_1.useRef)(false);
    const refIsNoMore = (0, react_1.useRef)(false);
    const refCurrentPage = (0, react_1.useRef)(1);
    const myProfile = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile);
    const isAnonymous = myProfile?.registration_status == 0;
    const translateY = (0, react_1.useRef)(new react_native_1.Animated.Value(0)).current;
    (0, react_1.useEffect)(() => {
        if (props.visible) {
            react_native_1.Animated.timing(translateY, {
                toValue: 1,
                duration: 300,
                useNativeDriver: false,
            }).start();
        }
    }, [props.visible]);
    const closeModal = () => {
        react_native_1.Animated.timing(translateY, {
            toValue: 0,
            duration: 300,
            useNativeDriver: false,
        }).start(() => props.onClose());
    };
    (0, react_1.useEffect)(() => {
        loadLikeUsers();
    }, [label]);
    (0, react_1.useEffect)(() => {
        if (!props.visible) {
            setUnfollowVisible(false);
            setSelectedUser(undefined);
        }
    }, [props.visible]);
    const loadLikeUsers = () => {
        if (refIsNoMore.current || isLoading)
            return;
        setLoading(true);
        Timeline_1.default.getTweetLikeUser(tweetId, refCurrentPage.current)
            .then((response) => {
            refCurrentPage.current = refCurrentPage.current + 1;
            if (refCurrentPage.current > response.data.last_page) {
                refIsNoMore.current = true;
            }
            if (response?.data?.data?.length > 0) {
                const filterData = response?.data?.data.filter((it) => {
                    const isExist = data.some((i) => i.user_handle == it.user_handle);
                    return !isExist;
                });
                setData([...data, ...filterData]);
            }
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => setLoading(false));
    };
    const handleLayout = (event) => {
        const { height } = event.nativeEvent.layout;
        setModalHeight(height);
    };
    const handleUnfollowUser = () => {
        const id = selectedUser?.user_id;
        if (refIsCallingAPI.current || !id)
            return;
        refIsCallingAPI.current = true;
        const nickname = selectedUser.nickname || constants_1.DEFAULT_NAME;
        setUnfollowVisible(false);
        setSelectedUser(undefined);
        Basic_1.default.unfollowUser(id)
            .then(() => {
            setToast(`${nickname}さんをフォロー解除しました`);
            setData((prev) => prev.map((user) => {
                if (user.user_id === id) {
                    return { ...user, is_followed: 0 };
                }
                return user;
            }));
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => {
            refIsCallingAPI.current = false;
        });
    };
    const handleFollowUser = (userId, nickname) => {
        if (isAnonymous) {
            return dispatch(slice_1.default.actions.showRequestLoginModal());
        }
        if (refIsCallingAPI.current)
            return;
        refIsCallingAPI.current = true;
        Basic_1.default.followUser(userId)
            .then(() => {
            setToast(`${nickname}さんをフォローしました`);
            setData((prev) => prev.map((user) => {
                if (user.user_id === userId) {
                    return { ...user, is_followed: 1 };
                }
                return user;
            }));
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => {
            refIsCallingAPI.current = false;
        });
    };
    const handlePress = (event, user, position) => {
        if (user.is_followed == 0) {
            handleFollowUser(user.user_id, user.nickname || constants_1.DEFAULT_NAME);
        }
        else {
            const { pageY } = event.nativeEvent;
            setModalPosition({ x: position.right, y: position.bottom });
            setSelectedUser(user);
            setUnfollowVisible(true);
        }
    };
    const renderItem = ({ item, index }) => {
        const hiddenFollowButton = item.user_handle == myProfile?.user_handle;
        return (react_1.default.createElement(UserItem, { item: item, index: index, isLastItem: data.length - 1 === index, onCloseModal: onClose, onFollowUser: handleFollowUser, onUnfollowUser: handlePress, hiddenFollowButton: hiddenFollowButton }));
    };
    return (react_1.default.createElement(react_native_1.Modal, { statusBarTranslucent: true, visible: props.visible, animationType: "fade", transparent: true, onRequestClose: closeModal, onShow: () => {
            helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
        }, onDismiss: () => {
            helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
        }, ...props },
        react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: closeModal, activeOpacity: 1, style: {
                flex: 1,
                backgroundColor: Colors_1.default.textHeaderOpacity60,
            } },
            react_1.default.createElement(react_native_1.Animated.View, { style: [
                    { flex: 1, justifyContent: 'flex-end', alignItems: 'center' },
                    {
                        transform: [
                            {
                                translateY: translateY.interpolate({
                                    inputRange: [0, 1],
                                    outputRange: [500, 0],
                                }),
                            },
                        ],
                    },
                ] },
                react_1.default.createElement(react_native_1.Pressable, { style: [
                        {
                            backgroundColor: 'white',
                            width: scale_1.width,
                            position: 'absolute',
                            paddingTop: 10,
                            borderTopLeftRadius: (0, scale_1.scale)(16),
                            borderTopRightRadius: (0, scale_1.scale)(16),
                            maxHeight: (0, scale_1.scale)(533),
                        },
                    ], onPress: () => {
                        setSelectedUser(undefined);
                        setUnfollowVisible(false);
                    }, onLayout: handleLayout },
                    react_1.default.createElement(react_native_1.View, { style: {
                            width: '100%',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderBottomWidth: 1,
                            borderBottomColor: '#DDDDDD',
                            paddingVertical: (0, scale_1.scale)(8),
                            paddingHorizontal: (0, scale_1.scale)(20),
                        } },
                        react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                                fontSize: (0, scale_1.moderateScale)(14),
                                color: '#292A33',
                                lineHeight: (0, scale_1.moderateScale)(21),
                            } }, label),
                        react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: closeModal },
                            react_1.default.createElement(IC_X_1.default, null))),
                    react_1.default.createElement(react_native_1.FlatList, { data: data, keyExtractor: (_, index) => `${index}`, renderItem: renderItem, contentContainerStyle: {
                            paddingTop: (0, scale_1.scale)(16),
                            paddingBottom: insets.bottom + (0, scale_1.scale)(24),
                        }, onScroll: ({ nativeEvent }) => {
                            if ((0, helpler_1.isCloseToBottom)(nativeEvent)) {
                                loadLikeUsers();
                            }
                        }, scrollEventThrottle: 400, ListFooterComponent: isLoading ? react_1.default.createElement(loading_1.LoadingView, { style: styles.loading }) : null }),
                    react_1.default.createElement(ModalUnfollowUser_1.default, { data: selectedUser, onClose: () => {
                            setUnfollowVisible(false);
                        }, visible: unfollowVisible, modalPosition: modalPosition, onChange: handleUnfollowUser }))),
            react_1.default.createElement(CustomToast, { toast: toast, onClose: () => setToast('') }))));
};
const styles = react_native_1.StyleSheet.create({
    buttonFollow: {
        height: (0, scale_1.scale)(30),
        width: (0, scale_1.scale)(96),
        borderRadius: (0, scale_1.scale)(3),
        backgroundColor: '#DDDDDD',
        justifyContent: 'center',
        alignItems: 'center',
    },
    textButton: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
    },
    viewModal: {
        backgroundColor: '#44A06B',
        width: (0, scale_1.scale)(343),
        position: 'absolute',
        alignItems: 'center',
        borderRadius: (0, scale_1.scale)(99),
        height: (0, scale_1.scale)(37),
        marginTop: (0, scale_1.scale)(10),
        flexDirection: 'row',
        marginLeft: (0, scale_1.scale)(16),
        paddingHorizontal: (0, scale_1.scale)(16),
    },
    textTitle1: {
        fontSize: (0, scale_1.moderateScale)(12),
        lineHeight: (0, scale_1.moderateScale)(22),
        textAlign: 'center',
    },
    userItem: {
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        paddingVertical: (0, scale_1.scale)(12),
        paddingHorizontal: (0, scale_1.scale)(16),
        borderBottomColor: '#DDDDDD',
    },
    userAvatar: {
        height: (0, scale_1.scale)(42),
        width: (0, scale_1.scale)(42),
        borderRadius: 99,
    },
    userInfo: {
        flex: 1,
        marginLeft: (0, scale_1.scale)(12),
    },
    userNickname: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.scale)(21),
        color: '#292A33',
    },
    userHandle: {
        marginTop: (0, scale_1.scale)(4),
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(17),
        color: '#888888',
    },
    button: {
        width: (0, scale_1.scale)(96),
        height: (0, scale_1.scale)(32),
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: (0, scale_1.scale)(4),
    },
    buttonLabel: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#545454',
    },
    absoluteContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
    confirmUnfollowButton: {
        // // position: "absolute",
        // // right: scale(18),
        // height: CONFIRM_MODAL_HEIGHT,
        // // width: scale(130),
        // borderRadius: scale(3),
        // backgroundColor: "#DDDDDD",
        // justifyContent: "center",
        // alignItems: "center",
        flexGrow: 1,
        maxWidth: 300,
        height: CONFIRM_MODAL_HEIGHT,
        paddingHorizontal: (0, scale_1.scale)(16),
        borderRadius: (0, scale_1.scale)(3),
        backgroundColor: '#DDDDDD',
        justifyContent: 'center',
        alignItems: 'center',
    },
    textNote: {
        color: '#D32F2F',
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
    },
    loading: {
        backgroundColor: 'transparent',
        paddingVertical: (0, scale_1.scale)(12),
    },
});
exports.default = ModalHistoryLike;
const CustomToast = (props) => {
    const { toast, onClose } = props;
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const toastAnim = (0, react_1.useRef)(new react_native_1.Animated.Value(0)).current;
    const refTimeout = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        if (toast) {
            clearTimeout(refTimeout.current);
            react_native_1.Animated.timing(toastAnim, {
                toValue: 1,
                duration: 0,
                useNativeDriver: true,
            }).start();
            refTimeout.current = setTimeout(() => {
                slideOut();
                clearTimeout(refTimeout.current);
            }, 2000);
        }
    }, [toast]);
    const slideOut = () => {
        react_native_1.Animated.spring(toastAnim, {
            toValue: 0,
            useNativeDriver: true,
        }).start(() => {
            onClose();
        });
    };
    const translateX = toastAnim.interpolate({
        inputRange: [0, 1],
        outputRange: [100, 0],
    });
    if (!toast)
        return null;
    return (react_1.default.createElement(react_native_1.View, { style: [
            toastStyles.container,
            {
                top: inset.top + (0, scale_1.scale)(16),
            },
        ] },
        react_1.default.createElement(react_native_1.Animated.View, { style: [
                toastStyles.view,
                {
                    transform: [{ translateX }],
                    opacity: toastAnim,
                },
            ] },
            react_1.default.createElement(IconCheckModal_1.default, null),
            react_1.default.createElement(CustomText_1.default, { weight: "300", style: toastStyles.text }, toast))));
};
const toastStyles = react_native_1.StyleSheet.create({
    container: {
        position: 'absolute',
        left: 0,
        right: 0,
        paddingHorizontal: (0, scale_1.scale)(16),
        overflow: 'hidden',
        zIndex: 100,
    },
    view: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: (0, scale_1.scale)(99),
        paddingVertical: (0, scale_1.scale)(8),
        paddingHorizontal: (0, scale_1.scale)(12),
        backgroundColor: '#44A06B',
    },
    text: {
        flex: 1,
        marginLeft: (0, scale_1.scale)(4),
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        textAlign: 'center',
        color: '#FEFEFE',
    },
});
